import { InjectionToken } from '@angular/core';
import { AbstractControl } from '@angular/forms';

/**
 * Export control validator plugin
 */
export const ControlValidatorPluginToken = new InjectionToken<ControlValidatorPlugin<any>>('ControlValidatorPlugin');
export const DecoratedControlValidatorPluginToken = new InjectionToken<ControlValidatorPlugin<any>>(
  'DecoratedControlValidatorPlugin'
);

export interface ControlConfigTuple<T> {
  control: AbstractControl;
  config?: T;
}

export interface ControlValidatorPlugin<T> {
  connect(t1: ControlConfigTuple<T>): void;
  connect(t1: ControlConfigTuple<T>, t2: ControlConfigTuple<T>): void;
  connect(t1: ControlConfigTuple<T>, t2: ControlConfigTuple<T>, t3?: ControlConfigTuple<T>): void;
  connect(...n: Array<ControlConfigTuple<T>>): void;
  /**
   * Method used to clean/remove everything that needs to be cleaned up, e.g. subscriptions
   */
  disconnect?(t1?: ControlConfigTuple<T>): void;
}
